import FixedPage from "./Layout/FixedPage";

export function Modal({
  children,
  onOutsideClick,
  className,
}: {
  children: React.ReactNode;
  onOutsideClick: () => void;
  className?: string;
}) {
  return (
    <FixedPage onOutsideClick={onOutsideClick} className={""}>
      <div
        className={`flex flex-col bg-White rounded-lg p-4 w-full max-w-md max-h-full overflow-y-auto  ${className}`}
        onClick={(e) => e.stopPropagation()}
        id="modal-content"
      >
        {children}
      </div>
    </FixedPage>
  );
}
